"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export const VerticalStoryImageDateNews = t0 => {
  const $ = _c(41);
  const {
    title: t1,
    timeAgo: t2,
    imageSrc: t3,
    slug,
    imageMetadata
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {
      hidden: false,
      value: "\u0BA4\u0BBF\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0BA4\u0BBF \u0BAE\u0BC7 \u0BAE\u0BBE\u0BA4 \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BA4\u0BB0\u0BBF\u0B9A\u0BA9 \u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC6\u0B9F\u0BCD: \u0BA8\u0BBE\u0BB3\u0BC8 \u0B86\u0BA9\u0BCD\u0BB2\u0BC8\u0BA9\u0BBF\u0BB2\u0BCD \u0BB5\u0BC6\u0BB3\u0BBF\u0BAF\u0BC0\u0B9F\u0BC1!",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const title = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {
      hidden: false,
      value: "May 17, 2023",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const timeAgo = t5;
  let t6;
  if ($[4] !== t3) {
    t6 = t3 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const imageSrc = t6;
  const titleValue = title?.value || "";
  const t7 = timeAgo?.value;
  let t8;
  if ($[6] !== t7) {
    t8 = getTimeAgo(t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const timeAgoValue = t8;
  let t9;
  if ($[8] !== imageSrc?.value) {
    t9 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[8] = imageSrc?.value;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const imageSrcValue = t9;
  let t10;
  if ($[10] !== imageMetadata || $[11] !== imageSrc?.customClass || $[12] !== imageSrc?.hidden || $[13] !== imageSrcValue || $[14] !== titleValue) {
    t10 = !imageSrc?.hidden && <div><div className="relative w-full aspect-[3/4] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`} style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[10] = imageMetadata;
    $[11] = imageSrc?.customClass;
    $[12] = imageSrc?.hidden;
    $[13] = imageSrcValue;
    $[14] = titleValue;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== title?.customClass || $[17] !== title?.hidden || $[18] !== titleValue) {
    t11 = !title?.hidden && <h3 className={`text-16-tamil-700 leading-[1.4] text-1B1B1B h-auto ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[16] = title?.customClass;
    $[17] = title?.hidden;
    $[18] = titleValue;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== timeAgo?.customClass || $[21] !== timeAgo?.hidden || $[22] !== timeAgoValue) {
    t12 = !timeAgo?.hidden && <span className={`text-12-tamil-500 ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[20] = timeAgo?.customClass;
    $[21] = timeAgo?.hidden;
    $[22] = timeAgoValue;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = slug ? `/${slug}` : undefined;
  let t14;
  if ($[24] !== imageSrcValue || $[25] !== slug || $[26] !== t13 || $[27] !== titleValue) {
    t14 = <div className="flex gap-3"><MessageIcon id="message-icon-3" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} articleUrl={t13} /></div>;
    $[24] = imageSrcValue;
    $[25] = slug;
    $[26] = t13;
    $[27] = titleValue;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <div className="flex justify-between items-center">{t12}{t14}</div>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t15) {
    t16 = <div className="flex flex-col gap-3">{t11}{t15}</div>;
    $[32] = t11;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t10 || $[36] !== t16) {
    t17 = <div className="flex flex-col overflow-hidden p-4 gap-4">{t10}{t16}</div>;
    $[35] = t10;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const content = t17;
  if (slug) {
    const t18 = `/${slug}`;
    let t19;
    if ($[38] !== content || $[39] !== t18) {
      t19 = <Link href={t18} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[38] = content;
      $[39] = t18;
      $[40] = t19;
    } else {
      t19 = $[40];
    }
    return t19;
  }
  return content;
};